import React, { PropTypes } from 'react';
import { NavLink } from 'react-router-dom';
import Media from 'react-media';

import ProductBasket from '../../containers/ProductBasket';

import './Controls.scss';

const Tabs = ({ productId, products }) => (
  <nav className="navbar">
    <ul className="nav navbar-nav">
      {products.map(({id, code, description, finalArea, monthlyEstimate}, idx) => 
        <li className="nav-item" key={idx}>
          <NavLink className="product-card d-flex flex-column" to={`/browse/${productId}/${id}/`}>
            <div className="code ">{code}</div>
            <div className="area ">{finalArea}m<sup>2</sup></div>
            <div className="description">{description}</div>
            <div className="price-row d-flex no-gutters">
              <div className="label">mēn.<sup>*</sup></div>
              <div className="col price">€ {monthlyEstimate}</div>
            </div>
          </NavLink>
        </li>
      )}
    </ul>
  </nav>
);


const MobileNote = () => (
  <div className="mobile-note">
    <i className="fa fa-info-circle" />
    <p>
      Lai veiktu pasūtījumu tiešsaistē, lūdzam izmantot interneta pārlūku uz datora vai planšetdatora vai zvanīt <a href="tel:67717665">67717665</a>.
    </p>
  </div>
)

const Controls = ({ id, products, product }) => {
  const hasLightBox = product && product.surfaces.find(s => s.hasLightBox);

  return (
    <div id="object-controls">
      <Tabs products={products} productId={id} />
      { hasLightBox && (
        <div className="light-box">
          <i className="fa fa-lightbulb-o"/> Reklāmas laukums aprīkots ar LED gaismas kasti.
        </div>
      )}
      {product && (
        <Media query={{ maxWidth: 575 }}>
          {matches => matches
              ? <MobileNote />
              : <ProductBasket product={product} />}
        </Media>
      )}
    </div>  
  )
}

Controls.propTypes = {
  product: PropTypes.object,
};

export default Controls;



// WEBPACK FOOTER //
// ./src/scenes/ObjectDetails/Controls.js